module.exports = __webpack_public_path__ + "static/media/bank-of-scotland.a135f5cb.svg";